import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { PessoaDetalheMobile } from '@/shared/components/pessoa/pessoa-detalhe-mobile/pessoa-detalhe-mobile';
import { Pessoa } from '@/shared/models/pessoa-info.model';
import { PessoaResponse } from '@/shared/components/pessoa/pessoa-detalhe/pessoa.model';

/**
 * Card do médico selecionado usado pelos relatórios que estendem `RelatorioMedicoBase`.
 * Encapsula a composição fixa de `app-pessoa-detalhe-mobile` (modo relatório) repetida em cada
 * um dos relatórios de médico, deixando o template de cada um com uma única linha.
 */
@Component({
    selector: 'app-card-medico-selecionado',
    standalone: true,
    imports: [PessoaDetalheMobile],
    templateUrl: './card-medico-selecionado.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CardMedicoSelecionado {
    /** Médico corrente exibido no card. */
    pessoa = input<Pessoa | undefined>();
    /** Dados completos do médico para o card. */
    pessoaResponse = input<PessoaResponse | null | undefined>();
    /** Emite quando o usuário pede para trocar o médico ("Selecionar Pessoa"). */
    alterar = output<void>();
}
